import React, { forwardRef } from "react";

import classNames from "classnames";

import {
  StyledToggle,
  StyledToggleCheckbox,
  StyledToggleSlider,
  StyledToggleSliderOff,
  StyledToggleSliderOn,
} from "./Styles";

export interface IToggleProps {
  /** Set hovered state. */
  hovered?: boolean;
  /** Custom classname for styling. */
  className?: string;
}

export const Toggle = forwardRef<
  HTMLInputElement,
  IToggleProps & Omit<React.ComponentPropsWithoutRef<"div">, keyof IToggleProps>
>(({ hovered, className, ...args }, ref) => {
  return (
    <StyledToggle
      className={classNames("c-toggle", className)}
      $isHovered={hovered}
      tabIndex={0}
    >
      <StyledToggleCheckbox ref={ref} type="checkbox" {...args} />
      <StyledToggleSlider>
        <StyledToggleSliderOn>ON</StyledToggleSliderOn>
        <StyledToggleSliderOff>OFF</StyledToggleSliderOff>
      </StyledToggleSlider>
    </StyledToggle>
  );
});

Toggle.displayName = "Toggle";
